export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const ACTION_LIST_NOTIFICATIONS = "ACTION_LIST_NOTIFICATIONS";

export const ACTION_SHOW_BADGE = "ACTION_SHOW_BADGE";
export const GET_SHOW_BADGE = "GET_SHOW_BADGE";
export const SET_SHOW_BADGE = "SET_SHOW_BADGE";

export const SET_CHANGE_STATE_NOTIFICATION = "SET_CHANGE_STATE_NOTIFICATION";
export const ACTION_CHANGE_STATE_NOTIFICATION = "ACTION_CHANGE_STATE_NOTIFICATION";


export const NOTIFICATIONS_M = "NOTIFICATIONS/";